import { Delete } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useDialogs } from "@toolpad/core";
import { RemoveClauseChecklistFromOrganizationDialog } from "../dialogs/RemoveClauseChecklistFromOrganizationDialog";

interface IProps {
    /**
     * The organization id to remove the clause checklist from.
     */
    organizationId: number;
    /**
     * The clause checklist id to remove from the organization.
     */
    clauseChecklistId: number;
}

export const RemoveClauseChecklistFromOrganization = ({
    organizationId,
    clauseChecklistId,
}: IProps) => {
    const dialogs = useDialogs();

    const handleRemove = () => {
        dialogs.open(RemoveClauseChecklistFromOrganizationDialog, {
            organizationId,
            clauseChecklistIds: [clauseChecklistId],
        });
    };

    return (
        <GridActionsCellItem
            icon={
                <Tooltip title="Remove Clause Checklist">
                    <Delete />
                </Tooltip>
            }
            label="Remove Clause Checklist"
            onClick={handleRemove}
        />
    );
};
